/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualKeyPublicMultibase: core.serialization.ObjectSchema<
    serializers.EqualKeyPublicMultibase.Raw,
    Truvity.EqualKeyPublicMultibase
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace EqualKeyPublicMultibase {
    export interface Raw {
        value: string;
    }
}
